import React, { useState, useEffect } from "react";
import axios from "axios";

const MouOutcomes = () => {
  const [outcomes, setOutcomes] = useState([]); // State to store fetched outcomes
  const [mous, setMous] = useState([]); // State to store MOU options
  const [searchTerm, setSearchTerm] = useState(""); // State for search input

  // Retrieve `id` from sessionStorage
  const sessionId = sessionStorage.getItem("selectedMouId");

  // Set a default search term if no session ID
  const defaultSearchTerm = "";
  const activeSearchTerm = sessionId || defaultSearchTerm;

  useEffect(() => {
    setSearchTerm(activeSearchTerm);
  
    const fetchData = async () => {
      try {
        // Fetch MOU data to get totalElements
        const mouResponse = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/mous`);
        const totalElements = mouResponse.data.page.totalElements;
  
         // Fetch MOU data to get totalElements
         const mouoResponseo = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/mouOutcomes`);
         const totalElementso = mouoResponseo.data.page.totalElements;


        // Fetch MOU Outcomes with the dynamic size
        const outcomesResponse = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/mouOutcomes?size=${totalElementso}`);
        const embeddedOutcomesData = outcomesResponse.data._embedded
          ? outcomesResponse.data._embedded.mouOutcomes
          : [];
        setOutcomes(embeddedOutcomesData);
  
        // Fetch MOU Options with the dynamic size
        const mouOptionsResponse = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/mous?size=${totalElements}`);
        const mouOptions = mouOptionsResponse.data._embedded.mous
          .filter((mou) => mou.mouId)
          .map((mou) => ({
            value: mou.mouId,
            label: `${mou.mouId} - ${mou.ptnOrg}`,
          }));
        setMous(mouOptions);
      } catch (error) {
        console.error("Error fetching MOU outcomes or options:", error);
      }
    };
  
    fetchData();
  }, [activeSearchTerm]); // Run when `activeSearchTerm` changes
  

  // Function to get the title based on MOU ID
  const getTitleByMouId = (mouId) => {
    const mou = mous.find((option) => option.value === mouId);
    return mou ? mou.label : "Title not found";
  };

  // Filter outcomes based on search term in particulars or title
  const filteredOutcomes = outcomes.filter((outcome) => {
    const mouId = outcome.mouId || (outcome._links?.self.href.split("/").pop());
    const outcomeTitle = getTitleByMouId(mouId);
    return (
      outcome.particulars?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      outcomeTitle.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1>MOU Outcomes</h1>
      <input
        type="text"
        placeholder="Search by particulars or title..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{
          marginBottom: "20px",
          padding: "10px",
          width: "100%",
          maxWidth: "400px",
          fontSize: "16px",
        }}
      />
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginTop: "20px",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#f0f0f0" }}>
            <th style={{ border: "1px solid #ddd", padding: "10px" }}>
              MOU ID - ORGANIZATION
            </th>
            <th style={{ border: "1px solid #ddd", padding: "10px" }}>
              Outcome Date
            </th>
            <th style={{ border: "1px solid #ddd", padding: "10px" }}>
              Particulars
            </th>
            <th style={{ border: "1px solid #ddd", padding: "10px" }}>
              Description
            </th>
          </tr>
        </thead>
        <tbody>
          {filteredOutcomes.map((outcome, index) => {
            const mouId =
              outcome.mouId || (outcome._links?.self.href.split("/").pop());
            const mouTitle = getTitleByMouId(mouId);
            return (
              <tr key={index}>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  {mouTitle}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  {outcome.outcomeDate}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  {outcome.particulars}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  {outcome.description}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {filteredOutcomes.length === 0 && (
        <p style={{ marginTop: "20px", color: "red" }}>
          No record found.
        </p>
      )}
    </div>
  );
};

export default MouOutcomes;
